import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipoPagamentoAppRoutingModule } from './tipo-pagamento.app-routing.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TipoPagamentoAppRoutingModule
  ]
})
export class TipoPagamentoAppModule { }
